export default __webpack_public_path__ + "static/media/arenPro3.b0b5a0e4.jpg";